// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rh_a bhr_a bhr_r bhr_sb bhr_ry bhr_rz","GroupsGrid__row__item":"rh_b bhr_be bhr_rz"};